import { Material } from 'src/api/endpoints/materials'
import { baseApi } from 'src/api'

export type GroupMaterial = {
    id: number;
    name: number;
    material: Material;
    openedAt: number;
    hasHomework: boolean;
}


const apiModule = baseApi.injectEndpoints({
    endpoints: builder => ({
        getGroupMaterials: builder.query<GroupMaterial[], {
            params: { groupId: number | string, subjectId: number | string }
        }>({
            providesTags: (_res, _err, { params }) => [{
                type: 'GroupMaterials',
                id: `${params.groupId}-${params.subjectId}`,
            }],
            query: ({ params }) => ({
                url: `/groups/${params.groupId}/subjects/${params.subjectId}/materials`,
                method: 'GET',
                errorMessage: 'Не удалось получить информацию об открытых материалах группы',
            }),
        }),
    }),
})

export const { useGetGroupMaterialsQuery } = apiModule